import { createContext } from 'react';
import LeadTrackingParams from 'types/Apis/LeadTrackingParams';

interface VdpEventContextInfo {
  trackingParams?: LeadTrackingParams;
}

export default createContext<VdpEventContextInfo>({});
